const debounce = (func) => {
  let timeout;
  const debounced = (...args) => {
    const later = () => {
      timeout = null;
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, 1000);
    if (!timeout) {
      func(...args);
    }
  };

  debounced.cancel = () => {
    clearTimeout(timeout);
    timeout = null;
  };
  return debounced;
};

export default debounce;
